import { ProjectUser, UserInline } from 'api/schema'

const getUserName = (user: UserInline | ProjectUser) => {
  return user.last_name && user.first_name ? user.last_name + ' ' + user.first_name : user.email
}

export default getUserName
